import { Box, Flex } from '@chakra-ui/react';
import { memo } from 'react';

import { isFullyPaid, progressPercent } from '@features/finance/financeMeta';

interface Props {
  target: number;
  received: number;
  width?: string;
}

const CollectionProgress = memo(({ target, received, width = '100%' }: Props) => {
  const percent = progressPercent(target, received);
  const isComplete = isFullyPaid(target, received);
  return (
    <Flex
      w={width}
      h="6px"
      bg="surface.accent"
      borderRadius="full"
      overflow="hidden"
      flexShrink={0}
    >
      <Box
        w={`${percent}%`}
        bg={isComplete ? 'green.500' : 'selection.500'}
        borderRadius="full"
        transition="width 0.2s ease"
      />
    </Flex>
  );
});
CollectionProgress.displayName = 'CollectionProgress';

export default CollectionProgress;
